'use client';

import FooterComponent from '@sympla/sympla-components/Footer';

function Footer() {
  return (
    <div data-testid="footer-container">
      <FooterComponent lang="pt" />
    </div>
  );
}

export default Footer;
